// extracted by mini-css-extract-plugin
module.exports = {"page":"StartPage_page__3Kv9J","welcomeSegment":"StartPage_welcomeSegment__DoSMk"};